import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Logo from '../../assets/Logo.png';


export default function OAuthCallback() {
  const { search } = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(search);
    const email = params.get("email");
    const name = params.get("name");

    if (email) {
      console.log("Google User:", { email, name });
      // Save user to state / send to backend / issue JWT
    }
  }, [search]);

  return (
  <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-violet-50 to-indigo-100">
    <div className="bg-white rounded-2xl shadow-xl p-10 w-full max-w-md text-center space-y-6 bg-gradient-to-br from-violet-200 to-indigo-50">

      {/* Logo */}
      <img
        src={Logo}
        alt="Outreach"
        className="h-10 mx-auto"
      />

      {/* Loader */}
      <div className="flex justify-center">
        <div className="h-10 w-10 border-4 border-violet-500 border-t-transparent rounded-full animate-spin"></div>
      </div>

      {/* Text */}
      <div>
        <h2 className="text-xl font-semibold text-gray-800">
          Logging you in
        </h2>
        <p className="text-sm text-gray-500 mt-1">
          Verifying your Google account…
        </p>
      </div>
       
      <p className="text-xs text-gray-400">
        Please don’t refresh this page
      </p>

    </div>
  </div>
)}
